<template>
  <div>
    <DocCard
      v-loading="loading"
      :data="data"
      @download="(e) => $emit('download', e)"
    />
    <div class="d-flex justify-content-end mt-3 mb-2">
      <div class="d-flex justify-content-center align-items-center">
        <el-button size="small" @click="$emit('close')">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import DocCard from './doc-card.vue'
export default {
  components: { DocCard },
  props: {
    amzFtyNoticeOutCode: { type: String, default: '' },
  },
  data() {
    return {
      data: [],
      loading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzFtyNoticeOutCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzFtyNoticeOutDocListApi({
          amzFtyNoticeOutCode: this.amzFtyNoticeOutCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.data = res.body.data
    },
  },
}
</script>
